import { render, staticRenderFns } from "./IncomeTransfer.vue?vue&type=template&id=0874c5b0&scoped=true"
import script from "./IncomeTransfer.vue?vue&type=script&lang=js"
export * from "./IncomeTransfer.vue?vue&type=script&lang=js"
import style0 from "./IncomeTransfer.vue?vue&type=style&index=0&id=0874c5b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0874c5b0",
  null
  
)

export default component.exports